import { render, staticRenderFns } from "./QTag.vue?vue&type=template&id=369838ac&"
import script from "./QTag.vue?vue&type=script&lang=js&"
export * from "./QTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports